import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { Organization } from 'data/models/Organization';

export const OrgHeaderView = SuperCritical(({ organization: org } : { organization : Organization }) =>
    <div className="org-profile-header">
        <img src={org.Image.ProfileUrl() || ''} />
        <div className="profile-header-details">
            <div className="profile-name pc-text-fixedwidth">{org.Name()}</div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/orgprofile/orgheaderview.tsx